import React from 'react';
import { Clock, Calendar, AlertTriangle } from 'lucide-react';
import { Card, CardContent } from '../ui/Card';
export function TimelineSection() {
  const scenarios = [{
    title: 'Small Driveway',
    size: 'Under 400 sq ft',
    duration: '3-5 days total'
  }, {
    title: 'Standard Driveway',
    size: '400-800 sq ft',
    duration: '5-8 days total'
  }, {
    title: 'Large Driveway',
    size: '800+ sq ft',
    duration: '7-12 days total'
  }, {
    title: 'Walkway / Patio',
    size: 'Any size',
    duration: '2-4 days total'
  }];
  return <section className="py-16 bg-white md:py-24" data-id="element-567">
      <div className="container mx-auto px-4 md:px-6" data-id="element-568">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-569">
          <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-570">
            Realistic Timeline Ranges
          </h2>
          <p className="mt-4 text-lg text-slate-600" data-id="element-571">
            We don't overpromise. These are typical durations for a complete
            project, from first shovel to final sweep.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-572">
          {scenarios.map((scenario, index) => <Card key={index} className="text-center border-slate-200 hover:border-primary/30 transition-colors" data-id="element-573">
              <CardContent className="pt-6 pb-6" data-id="element-574">
                <div className="w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center mx-auto mb-4 text-slate-600" data-id="element-575">
                  <Clock className="h-6 w-6" data-id="element-576" />
                </div>
                <h3 className="font-bold text-slate-900 mb-1" data-id="element-577">
                  {scenario.title}
                </h3>
                <p className="text-xs text-slate-500 mb-3 uppercase tracking-wide" data-id="element-578">
                  {scenario.size}
                </p>
                <p className="text-xl font-bold text-primary" data-id="element-579">
                  {scenario.duration}
                </p>
              </CardContent>
            </Card>)}
        </div>

        <div className="bg-amber-50 border border-amber-100 rounded-xl p-6 max-w-4xl mx-auto" data-id="element-580">
          <div className="flex items-start gap-4" data-id="element-581">
            <AlertTriangle className="h-6 w-6 text-amber-600 shrink-0 mt-1" data-id="element-582" />
            <div data-id="element-583">
              <h4 className="font-bold text-amber-900 mb-2" data-id="element-584">
                Critical Path Factors
              </h4>
              <p className="text-amber-800 text-sm mb-4" data-id="element-585">
                These external factors can impact your schedule. We monitor them
                closely and keep you updated.
              </p>
              <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-2 text-sm text-amber-700" data-id="element-586">
                <li className="flex items-center gap-2" data-id="element-587">
                  <span className="h-1.5 w-1.5 rounded-full bg-amber-500" data-id="element-588"></span>
                  Weather windows (concrete needs 5°C+)
                </li>
                <li className="flex items-center gap-2" data-id="element-589">
                  <span className="h-1.5 w-1.5 rounded-full bg-amber-500" data-id="element-590"></span>
                  Concrete curing time (3-7 days)
                </li>
                <li className="flex items-center gap-2" data-id="element-591">
                  <span className="h-1.5 w-1.5 rounded-full bg-amber-500" data-id="element-592"></span>
                  Electrical panel upgrades (if needed, add 1-2 days)
                </li>
                <li className="flex items-center gap-2" data-id="element-593">
                  <span className="h-1.5 w-1.5 rounded-full bg-amber-500" data-id="element-594"></span>
                  Permit processing (varies by municipality)
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="text-center text-xs text-slate-400 mt-6" data-id="element-595">
          *These are typical ranges. Your site assessment will include a
          project-specific timeline.
        </p>
      </div>
    </section>;
}